// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"688":"WxLaunchHack","962":"QQShare"}[chunkId] + "." + {"688":"8da9ff0404","962":"522a2a80da"}[chunkId] + ".js";
};